/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SuggestionBodyWeekInReview_suggestionPayload = {
    readonly rewindHistory?: {
        readonly " $fragmentRefs": FragmentRefs<"WeekInReviewScrubber_rewindHistory">;
    } | undefined;
    readonly rewindWeek?: string | undefined;
    readonly " $refType": "SuggestionBodyWeekInReview_suggestionPayload";
};
export type SuggestionBodyWeekInReview_suggestionPayload$data = SuggestionBodyWeekInReview_suggestionPayload;
export type SuggestionBodyWeekInReview_suggestionPayload$key = {
    readonly " $data"?: SuggestionBodyWeekInReview_suggestionPayload$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionBodyWeekInReview_suggestionPayload">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestionBodyWeekInReview_suggestionPayload",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "RewindHistory",
                    "kind": "LinkedField",
                    "name": "rewindHistory",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "WeekInReviewScrubber_rewindHistory"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rewindWeek",
                    "storageKey": null
                }
            ],
            "type": "SuggestionResultWeekInReviewPayload",
            "abstractKey": null
        }
    ],
    "type": "SuggestionResultPayload",
    "abstractKey": "__isSuggestionResultPayload"
} as any;
(node as any).hash = 'ba79ebb5a4d283d6b1c779ca61de063e';
export default node;
